<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3 class="sp-color__accent">
      {{ 'COMPANIES.EDIT_CTA' | translate }}
    </h3>
    <form
      [formGroup]="company_edit_form_group"
      class="sp-margin__top-x2">
      <mat-form-field
        class="sp-width__full sp-margin__bottom-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'STORES.BUSINESS_NAME_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="business_name"
          [errorStateMatcher]="error_matcher"
          required />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-margin__bottom-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'STORES.VAT_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="vat"
          [errorStateMatcher]="error_matcher"
          required />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-margin__bottom-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'STORES.WEBSITE_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="website"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <app-shared-button
        class="sp-width__full"
        [button_class]="'sp-button__main'"
        [spinner_class]="'sp-spinner__main'"
        [cta]="'GENERAL.CONFIRM_CTA'"
        [is_disabled]="!isFormValid() || is_company_edit_running"
        [is_spinner_visible]="is_company_edit_running"
        (click)="onConfirmClick()"></app-shared-button>
    </form>
  </div>
</div>
